import {Component, inject, NgZone, OnInit, signal} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {DemoEndModalComponent} from '../demo-end-modal/demo-end-modal.component';
import {DemoExternalComponent} from '@modules/activities/core/player-components/demo/demo-external.component';
import {combineLatest} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {InstanceVariablesService} from 'shared/instance-variables.service';
import {environment} from '../../../../../../src/environments/environment';

const urlsDemos = [
    {id: 'junior', url: environment.baseApiUrl('amazon_python') + 'sites/default/files/story/CTZC_Jr_Demo/'},
    {id: 'explorer', url: environment.baseApiUrl('amazon_python') + 'sites/default/files/story/CTZC_College_Demo/'},
];

@Component({
    selector: 'app-demo-player',
    imports: [
        DemoExternalComponent
    ],
    templateUrl: './demo-player.component.html',
    styleUrl: './demo-player.component.scss'
})
export class DemoPlayerComponent implements OnInit {

    private router = inject(Router);
    private ngZone = inject(NgZone);
    private dialog = inject(MatDialog);
    private sanitizer = inject(DomSanitizer);
    private activatedRoute = inject(ActivatedRoute);
    private instanceVariablesService = inject(InstanceVariablesService);

    public iframeUrl = signal<SafeResourceUrl>(null);

    private demoId$ = this.activatedRoute.paramMap.pipe(map(params => params.get('demoId')));
    private backendDrivenIndex$ = this.activatedRoute.queryParams.pipe(map(params => +(params.index ?? 0)));
    private backendDrivenDemo$ = this.instanceVariablesService.instanceVariables$.pipe(map(instanceVariables => instanceVariables.get('demoUrls') ?? []));
    private querySource$ = this.activatedRoute.paramMap.pipe(map(params => params.get('mtm_source')));

    ngOnInit() {
        const defaultUrl = urlsDemos[0].url;

        combineLatest([this.demoId$, this.backendDrivenIndex$, this.backendDrivenDemo$]).subscribe(([demoId, index, backendDemoUrls]) => {
            // this.platform = null;
            if (demoId === 'backend-driven') {
                this.iframeUrl.set(this.toIframeUrl(backendDemoUrls[index]));
            } else {
                const demoUrl = urlsDemos.find(u => u.id === demoId)?.url || defaultUrl;
                this.iframeUrl.set(this.toIframeUrl(demoUrl));
            }
        });
    }

    public onPlatformValidate(mode, success, error) {
        console.log('mode : ' + mode);
        if (mode === 'cancel') {
            console.warn('cancel');
            return;
        } else if (mode === 'nextImmediate') {
            console.warn(mode);
        } else if (mode === 'log') {
            // nothing
        } else {
            // ici on réussi l'activité et on ouvre la modale
            this.onActivityDone();
        }
    }

    private toIframeUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url.includes('?') ? url + '&log=1' : url + '?log=1');
    }

    private openModal() {
        return this.dialog.open(
            DemoEndModalComponent, {
                panelClass: 'demo-end-modal-dialog-wrapper'
            }
        );
    }

    public onActivityDone(): void {
        combineLatest([
            this.demoId$,
            this.querySource$,
            this.backendDrivenIndex$,
            this.backendDrivenDemo$
        ])
            .pipe(take(1))
            .subscribe(([demoId, source, index, backendDemoUrls]) => {
                const navigateToNextDemo = () =>
                    this.ngZone.run(() => this.router.navigate(['demo', 'backend-driven'], {queryParams: {index: index + 1}, queryParamsHandling: 'merge'}));

                const navigateToRegister = () => {
                    const queryParams = demoId === 'backend-driven' ? {mtm_campaign: 'tunnel-de-conversion'} : {};
                    queryParams['index'] = undefined;
                    this.ngZone.run(() => this.router.navigate(['register'], {queryParams, queryParamsHandling: 'merge'}));
                };

                const handleModalClose = () => {
                    if (demoId === 'backend-driven' && index < backendDemoUrls.length - 1) {
                        navigateToNextDemo();
                    } else {
                        navigateToRegister();
                    }
                };

                this.openModal().afterClosed().pipe(take(1)).subscribe(handleModalClose);
            });
    }
}
